import React, { useState, useEffect } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import AccordionActions from "@material-ui/core/AccordionActions";
import Fab from "@material-ui/core/Fab";
import SaveIcon from "@material-ui/icons/Save";
import CachedIcon from "@material-ui/icons/Cached";
import Base from "../../../base/views/base";
import LandingPageFooter from "../../../LandingPage/views/LandingPageFooter";
import MaterialTable, { MTableToolbar } from "material-table";
import { getSessionData } from "../../../base/helper/baseHelper";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import ConfirmationDialog from "../../../base/views/ConfirmationDialog";
import { getSuppliers } from "../../../Ancillary/SupplierManagement/helper/supplierManagementHelper";
import {
  getNonSaleableReturn,
  submitNonSaleableReturn,
  DeleteNonSaleableReturnStage,
  UpdateStageNonSaleableReturn,
  GetCommentsNonSaleableReturn,
  UpdateCommentsNonSaleableReturn,
} from "../helper/nonSaleableReturnHelper";
import {
  addNewNonSaleableReturnAction,
  deleteNonSaleableReturnAction,
} from "../../../../../store/nonsaleablereturn/actions";
import { connect } from "react-redux";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CommentPopup from "../../../base/views/CommentPopup";
import ChatIcon from "@material-ui/icons/Chat";
import SelectableSearch from "../../../base/views/SelectableSearch";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
  },

  pricingheader: {
    marginTop: theme.spacing(2),
  },
  card: {
    height: 400,
    width: "100%",
    maxWidth: 195,
    position: "relative",
    borderRadius: 16,
    display: "flex",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    flexDirection: "column",
    paddingTop: 4,
    paddingBottom: 4,
    "&:last-child": {
      paddingRight: 5,
    },
    flexShrink: 0,
    marginRight: theme.spacing(5),
  },
  cardPricing: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    marginBottom: theme.spacing(2),
  },
  cardHeader: {
    fontSize: "small",
  },
  cardpaidlist: {
    paddingTop: 5,
    justifyContent: "center",
    paddingLeft: 10,
  },
  cardpaid: {
    paddingTop: 2,
    paddingLeft: 2,
    fontSize: "small",
    justifyContent: "center",
  },
  planswitcher: {
    paddingBottom: 12,
    paddingTop: 4,
  },
  showallplan: {
    paddingBottom: 12,
    paddingTop: 10,
    justifyContent: "center",
    display: "flex",
  },
  cardpaidlisticon: {
    position: "relative",
    top: 8,
  },
  gridlisticon: {
    position: "relative",
    left: 25,
  },
  appBar: {
    backgroundColor: "rgba(255,255,255,0.5)",
  },
  title: {
    flexGrow: 1,
    color: "rgba(0, 0, 0, 0.7);",
  },
  labels: {
    width: "90%",
    padding: "0.4rem 0rem",
    fontSize: "1rem",
    justifyContent: "space-between",
  },
  plantable: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    marginBottom: "1%",
  },
  plantable2: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    marginBottom: "1%",
  },
  plantableheader: {
    alignItems: "center",
    display: "inline-flex",
    flexWrap: "Wrap",
    justifyContent: "left",
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
    width: "100%",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const initialFValues = {
  boxnumber: "",
  barcode: "",
  partialfull: "FULL",
  looseQty: "0",
  comments: "",
  supplier: "",
  selectedSupplier: { id: 0, optionname: "" },
};

function NonSaleableReturnLandingPage(props) {
  const classes = useStyles();
  const [errors, setErrors] = React.useState({});
  const [addNonSaleableReturnData, setState] = useState(initialFValues);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [showQty, setShowQty] = useState("0");
  const [previousBoxNumber, setPreviousBoxNumber] = useState("");
  const [openBoxNumberDialog, setOpenBoxNumberDialog] = useState(false);
  const [
    openReceivedNonSaleableReturnsDialog,
    setOpenReceivedNonSaleableReturnsDialog,
  ] = useState(false);
  const [openDoubleConfirmDialog, setOpenDoubleConfirmDialog] = useState(false);
  const [deleteNonSaleableReturnObj, setDeleteNonSaleableReturnObj] = useState(
    []
  );
  const [gridData, setGridData] = useState([]);
  const [storeId, setStoreId] = useState("");
  const [userId, setUserId] = useState("");
  const BoxNumberRef = React.useRef();
  const looseQtyRef = React.useRef();
  const barcodeRef = React.useRef();
  const [openCommentPopup, setOpenCommentPopup] = useState(false);
  const [ndc, setNdc] = useState("");
  const [comment, setComment] = useState("");
  const [enableComment, setEnableComment] = useState(false);

  const {
    nonSaleableReturns,
    addNonSaleableReturn,
    deleteNonSaleableReturn,
  } = props;

  const [supplierData, setSupplierData] = React.useState({
    load: false,
    values: [],
  });

  useEffect(() => {
    setGridData([]);
    setUserId(getSessionData({ key: "userId" }));
    const store = JSON.parse(getSessionData({ key: "store" }));
    setStoreId(store.storeid);
    if (storeId) {
      GetNonSaleableReturn();
    }
    //eslint-disable-next-line
  }, [userId, storeId]);

  useEffect(() => {
    if (nonSaleableReturns) {
      setGridData(nonSaleableReturns);
      setState({
        ...addNonSaleableReturnData,
        barcode: "",
      });
      setShowQty("0");
    } else {
      BoxNumberRef.current.focus();
    }
    //eslint-disable-next-line
  }, [nonSaleableReturns]);

  const GetNonSaleableReturn = () => {
    if (userId !== "" && storeId !== "") {
      const data = {
        store_id: storeId,
        user_id: userId,
      };
      getNonSaleableReturn(data)
        .then((response) => {
          if (response && response.data && response.data.length > 0) {
            setGridData(response.data);
            barcodeRef.current.focus();
            setState({
              ...addNonSaleableReturnData,
              selectedSupplier: {
                id: response.data[0].supplier_id,
                optionname: response.data[0].supplier,
              },
              barcode: "",
            });
            setOpenReceivedNonSaleableReturnsDialog(true);
          } else {
            BoxNumberRef.current.focus();
          }
        })
        .catch((err) => {});
    }
  };

  const validate = (fieldValues = addNonSaleableReturnData) => {
    let temp = { ...errors };

    if ("barcode" in fieldValues) {
      temp.barcode = fieldValues.barcode === "" ? "Barcode is required" : "";
    }

    if ("boxnumber" in fieldValues) {
      temp.boxnumber =
        fieldValues.boxnumber === "" ? "Box Number is required" : "";
    }

    if (
      "partialfull" in fieldValues &&
      fieldValues.partialfull === "PARTIAL" &&
      "looseQty" in fieldValues
    ) {
      temp.looseQty =
        fieldValues.looseQty === "0" || fieldValues.looseQty === ""
          ? "loose Qty is required"
          : "";
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const Scan = (e) => {
    if (e.target.id === "barcode" && (e.type === "click" || e.which === 13)) {
      if (
        addNonSaleableReturnData &&
        addNonSaleableReturnData.partialfull &&
        addNonSaleableReturnData.partialfull === "FULL"
      ) {
        if (validate()) {
          addNonSaleableReturn({
            user_id: userId,
            store_id: storeId,
            partialfull: addNonSaleableReturnData.partialfull,
            boxnumber: addNonSaleableReturnData.boxnumber,
            barcode: addNonSaleableReturnData.barcode,
            loose_qty: addNonSaleableReturnData.looseQty,
            comments: addNonSaleableReturnData.comments,
            supplier: addNonSaleableReturnData.selectedSupplier.optionname,
            supplier_id: addNonSaleableReturnData.selectedSupplier.id,
          });

          setPreviousBoxNumber(addNonSaleableReturnData.boxnumber);

          setState({
            ...addNonSaleableReturnData,
            barcode: "",
            looseQty: "0",
            comments: "",
          });
          setShowQty("1");
        }
      } else {
        looseQtyRef.current.focus();
        setState({
          ...addNonSaleableReturnData,
          looseQty: "",
        });
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...addNonSaleableReturnData,
      [name]: value,
    });
  };

  const handleSupplierChange = (event, value) => {
    if (value && value.id) {
      setState({
        ...addNonSaleableReturn,
        selectedSupplier: { id: value.id, optionname: value.optionname },
        supplier: value.optionname,
      });
    } else {
      setState({
        ...addNonSaleableReturn,
        selectedSupplier: {},
        supplier: "",
      });
    }
  };

  const addNonSaleableReturnDataFromQty = (e) => {
    if (e.target.id === "looseQty" && (e.type === "click" || e.which === 13)) {
      if (validate()) {
        addNonSaleableReturn({
          user_id: userId,
          store_id: storeId,
          partialfull: addNonSaleableReturnData.partialfull,
          boxnumber: addNonSaleableReturnData.boxnumber,
          barcode: addNonSaleableReturnData.barcode,
          loose_qty: addNonSaleableReturnData.looseQty,
          comments: addNonSaleableReturnData.comments,
          supplier: addNonSaleableReturnData.selectedSupplier.optionname,
          supplier_id: addNonSaleableReturnData.selectedSupplier.id,
        });
        setPreviousBoxNumber(addNonSaleableReturnData.boxnumber);

        setState({
          ...addNonSaleableReturnData,
          barcode: "",
          looseQty: "0",
          comments: "",
          partialfull: "FULL",
        });
      }
    }
  };

  const HandleAddNonSaleableReturn = (e) => {
    e.preventDefault();
    if (validate()) {
      addNonSaleableReturn({
        user_id: userId,
        store_id: storeId,
        partialfull: addNonSaleableReturnData.partialfull,
        boxnumber: addNonSaleableReturnData.boxnumber,
        barcode: addNonSaleableReturnData.barcode,
        loose_qty: addNonSaleableReturnData.looseQty,
        comments: addNonSaleableReturnData.comments,
        supplier: addNonSaleableReturnData.selectedSupplier.optionname,
        supplier_id: addNonSaleableReturnData.selectedSupplier.id,
      });

      setPreviousBoxNumber(addNonSaleableReturnData.boxnumber);

      setState({
        ...addNonSaleableReturnData,
        barcode: "",
        looseQty: "0",
        comments: "",
        partialfull: "FULL",
      });
    }
  };

  const HandleSubmitToNonSaleableReturn = (e) => {
    e.preventDefault();
    if (gridData && gridData.length > 0) {
      submitNonSaleableReturn({
        store_id: storeId,
        user_id: userId,
      }).then((response) => {
        if (response) setGridData([]);
        setPreviousBoxNumber("");
        setState({
          ...addNonSaleableReturnData,
          barcode: "",
          boxnumber: "",
          looseQty: "",
          comments: "",
          partialfull: "FULL",
        });
        BoxNumberRef.current.focus();
      });
    }
  };

  const onDeleteOkButtonClick = (rowData) => {
    let data = {
      store_id: storeId,
      user_id: userId,
      ndc: rowData.ndc,
      upc: rowData.upc,
      lot: rowData.lot,
    };
    setDeleteNonSaleableReturnObj(data);
    setOpenDeleteDialog(true);
  };

  const handleDelete = () => {
    setOpenDeleteDialog(false);
    deleteNonSaleableReturn(deleteNonSaleableReturnObj);
    setDeleteNonSaleableReturnObj([]);
  };

  const boxnumberonBlur = (e) => {
    if (
      previousBoxNumber &&
      e.target.value &&
      e.target.value !== previousBoxNumber
    ) {
      setOpenBoxNumberDialog(true);
    }
  };

  const handleFullPartial = (e) => {
    setState({
      ...addNonSaleableReturnData,
      partialfull: e.target.value,
      looseQty: "0",
      comments: "",
      barcode: "",
    });
    setShowQty("0");
    setErrors({});
    barcodeRef.current.focus();
  };

  const onBoxNumberOkButtonClick = () => {
    const data = {
      user_id: userId,
      store_id: storeId,
      boxnumber: addNonSaleableReturnData.boxnumber,
    };
    UpdateStageNonSaleableReturn(data)
      .then((response) => {
        if (response && response.length > 0) {
          setGridData(response);
          setOpenBoxNumberDialog(false);
          setPreviousBoxNumber(response[response.length - 1].boxnumber);
          setState({
            ...addNonSaleableReturnData,
            partialfull: "FULL",
            looseQty: "0",
            barcode: "",
          });
        }
      })
      .catch((err) => {});
  };

  const enableDoubleConfirm = () => {
    setOpenDoubleConfirmDialog(true);
  };

  const onReceivedNonSaleableReturnsCancelClick = () => {
    // barcodeRef.current.focus();
    setOpenReceivedNonSaleableReturnsDialog(false);
    setOpenDoubleConfirmDialog(false);
    if (gridData && gridData.length > 0) {
      setState({
        ...addNonSaleableReturnData,
        boxnumber: gridData[gridData.length - 1].boxno,
      });
    }
  };

  const onReceivedNonSaleableReturnsOkButtonClick = () => {
    setOpenReceivedNonSaleableReturnsDialog(false);
    setOpenDoubleConfirmDialog(false);
    var data = {
      user_id: userId,
      store_id: storeId,
    };
    DeleteNonSaleableReturnStage(data)
      .then((response) => {
        setGridData([]);
        setState({
          ...addNonSaleableReturnData,
          boxnumber: "",
          barcode: "",
        });
        setPreviousBoxNumber("");
        BoxNumberRef.current.focus();
      })
      .catch((err) => {});
  };

  const loadSupplierDropdown = () => {
    setSupplierData({ ...supplierData, load: true });
    getSuppliers(storeId)
      .then((response) => {
        let dropdownData = [];
        if (response.data.length)
          dropdownData = response.data.map((obj) => ({
            id: obj.supplier_id,
            optionname: obj.aliasname,
          }));
        setSupplierData({ load: false, values: dropdownData });
      })
      .catch((err) => {});
  };

  const handleCommentSubmit = () => {
    var data = {
      user_id: userId,
      store_id: storeId,
      ndc: ndc,
      comment: comment,
    };
    UpdateCommentsNonSaleableReturn(data)
      .then((response) => {
        setComment("");
        setOpenCommentPopup(false);
        setNdc("");
      })
      .catch((err) => {});
  };

  const getComments = (event, rowData) => {
    setNdc(rowData.ndc);
    GetCommentsNonSaleableReturn({
      user_id: userId,
      store_id: storeId,
      ndc: rowData.ndc,
    }).then((response) => {
      if (response && response.length > 0) {
        setComment(response[0].message);
      }
      setOpenCommentPopup(true);
    });
  };

  return (
    <div style={{ display: "flex" }}>
      <Base showBaseMenu={true} title="Non Saleable Returns">
        <Grid container spacing={2} style={{ marginTop: "2.5%" }}>
          <Grid item xs={12} sm={2}>
            <SelectableSearch
              required
              autoFocus
              value={addNonSaleableReturn.selectedSupplier}
              data={supplierData}
              name="supplier"
              label="Supplier"
              id="supplier"
              loading={loadSupplierDropdown}
              onChangeEvent={handleSupplierChange}
              variantType="standard"
              {...(errors.selectedSupplier && {
                error: true,
                helperText: errors.selectedSupplier,
              })}
            ></SelectableSearch>
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              value={addNonSaleableReturnData.boxnumber}
              onChange={handleInputChange}
              fullWidth
              id="boxnumber"
              label="Box Number"
              name="boxnumber"
              autoComplete="boxno"
              inputRef={BoxNumberRef}
              onBlur={boxnumberonBlur}
              {...(errors.boxnumber && {
                error: true,
                helperText: errors.boxnumber,
              })}
            />
          </Grid>
          <Grid container item xs={12} sm={3}>
            <RadioGroup
              row
              aria-label="scan"
              name="row-radio-buttons-group"
              value={addNonSaleableReturnData.partialfull}
              onChange={handleFullPartial}
              tabIndex={-1}
              style={{
                border: "",
                display: "flex",
                justifyContent: "space-evenly",
                width: "100%",
              }}
            >
              <FormControlLabel
                default
                value="FULL"
                control={<Radio style={{ color: "rgb(22, 177, 255)" }} />}
                label="Full"
              />
              <FormControlLabel
                value="PARTIAL"
                control={<Radio style={{ color: "rgb(22, 177, 255)" }} />}
                label="Partial"
              />
            </RadioGroup>
          </Grid>
          <Grid item xs={12} sm={2}>
            <div tabIndex="-1" onKeyDown={Scan}>
              <TextField
                value={addNonSaleableReturnData.barcode}
                onChange={handleInputChange}
                fullWidth
                id="barcode"
                label="Barcode"
                name="barcode"
                inputRef={barcodeRef}
                autoComplete="barcode"
                {...(errors.barcode && {
                  error: true,
                  helperText: errors.barcode,
                })}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={2}>
            <div onKeyDown={addNonSaleableReturnDataFromQty}>
              <TextField
                value={
                  addNonSaleableReturnData.partialfull === "FULL"
                    ? showQty
                    : addNonSaleableReturnData.looseQty
                }
                onChange={handleInputChange}
                fullWidth
                id="looseQty"
                inputRef={looseQtyRef}
                label={
                  addNonSaleableReturnData.partialfull === "FULL"
                    ? "Qty"
                    : "Loose Qty"
                }
                name="looseQty"
                disabled={
                  addNonSaleableReturnData.partialfull === "FULL" ? true : false
                }
                InputProps={{ inputProps: { min: "0", step: "1" } }}
                autoComplete="looseQty"
                {...(errors.looseQty && {
                  error: true,
                  helperText: errors.looseQty,
                })}
                type="number"
              />
            </div>
          </Grid>
          {addNonSaleableReturnData &&
            addNonSaleableReturnData.partialfull &&
            addNonSaleableReturnData.partialfull === "PARTIAL" && (
              <Grid item xs={12} sm={1}>
                <AccordionActions>
                  <Fab
                    size="small"
                    color="primary"
                    aria-label="add"
                    onClick={HandleAddNonSaleableReturn}
                  >
                    <SaveIcon />
                  </Fab>
                </AccordionActions>
              </Grid>
            )}
        </Grid>
        {/* </Container> */}
        <div className={classes.root}>
          <MaterialTable
            title={
              "Total Quantity Full/Partial: " +
              gridData?.reduce(
                (total, item) => total + item.fullquantity * 1,
                0
              ) +
              "/" +
              gridData?.reduce(
                (total, item) => total + item.partialquantity * 1,
                0
              )
            }
            columns={[
              {
                title: "Description",
                field: "description",
                cellStyle: { width: "35%" },
              },
              { title: "NDC", field: "ndc", cellStyle: { width: "20%" } },
              { title: "Pack Size", field: "packsize" },
              {
                title: "Manufacturer",
                field: "manufacturer",
                cellStyle: { width: "15%" },
              },
              { title: "Lot#", field: "lot", cellStyle: { width: "10%" } },
              { title: "Exp Date", field: "expirationdate" },
              { title: "Full Qty", field: "fullquantity" },
              { title: "Partial Qty", field: "partialquantity" },
            ]}
            data={gridData}
            actions={[
              {
                icon: "delete",
                tooltip: "Delete",
                onClick: (event, rowData) => {
                  onDeleteOkButtonClick(rowData);
                },
                position: "row",
              },
              {
                icon: () => <ChatIcon />,
                tooltip: "Comment",
                onClick: (event, rowData) => getComments(event, rowData),
                disabled: enableComment ? true : false,
                position: "row",
              },
            ]}
            options={{
              rowStyle: (rowData) => {
                if (rowData.expiryflag === "1") {
                  return { backgroundColor: "#FFBF00" };
                } else if (rowData.expiryflag === "2") {
                  return { backgroundColor: "rgb(244, 67, 54)" };
                }

                return {};
              },
              maxBodyHeight: 670,
              paging: true,
              pageSize: 25,
              pageSizeOptions: [25, 50, 100],
              headerStyle: {
                backgroundColor: "rgba(255,255,255,1)",
                color: "black",
              },
            }}
            components={{
              Toolbar: (props) => (
                <Box display="flex">
                  <Box flexGrow={1}>
                    <MTableToolbar {...props} />
                  </Box>
                  <Box paddingBottom={1.5} paddingTop={2}>
                    <Button
                      onClick={(e) => {
                        HandleSubmitToNonSaleableReturn(e);
                      }}
                      fullWidth={true}
                      color="primary"
                      variant="contained"
                      size="medium"
                      style={{
                        backgroundColor: "rgb(22, 177, 255)",
                        borderRadius: "0.5rem",
                      }}
                    >
                      Submit
                    </Button>
                  </Box>
                  <Tooltip title="Create New Session">
                    <IconButton
                      color="primary"
                      style={{ color: "rgb(22, 177, 255)" }}
                      size="medium"
                      onClick={() => {
                        setOpenReceivedNonSaleableReturnsDialog(true);
                      }}
                    >
                      <CachedIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                </Box>
              ),
            }}
            onSelectionChange={(rows) => {
              if (rows.length > 1) {
                setEnableComment(true);
              } else {
                setEnableComment(false);
              }
            }}
          />
        </div>
        {/* </Container> */}
        <LandingPageFooter />
        <CommentPopup
          title="Add Comments"
          openDialog={openCommentPopup}
          closeDialog={setOpenCommentPopup}
          comment={comment}
          onCommentChange={setComment}
          onSubmit={handleCommentSubmit}
          OkButtonText="Submit"
        />
        <ConfirmationDialog
          title="Do you want to proceed?"
          openDialog={openDeleteDialog}
          closeDialog={setOpenDeleteDialog}
          popupTitle="Non Saleable Return"
          onSubmit={handleDelete}
        />
        <ConfirmationDialog
          openDialog={openReceivedNonSaleableReturnsDialog}
          closeDialog={setOpenReceivedNonSaleableReturnsDialog}
          title="Can you please Confirm?"
          popupTitle="Non Saleable Return"
          onSubmit={enableDoubleConfirm}
          onCancel={onReceivedNonSaleableReturnsCancelClick}
          CancelButtonText="Continue Scanning"
          OkButtonText="Create New session"
        />
        <ConfirmationDialog
          openDialog={openDoubleConfirmDialog}
          closeDialog={setOpenDoubleConfirmDialog}
          title="The scanned data will be deleted. Do you want to create new session?"
          popupTitle="Non Saleable Return"
          onSubmit={onReceivedNonSaleableReturnsOkButtonClick}
          onCancel={onReceivedNonSaleableReturnsCancelClick}
          CancelButtonText="No"
          OkButtonText="Yes"
        />
        <ConfirmationDialog
          openDialog={openBoxNumberDialog}
          closeDialog={setOpenBoxNumberDialog}
          title="Do you want proceed with new Box Number?"
          popupTitle="Non Saleable Return"
          onSubmit={onBoxNumberOkButtonClick}
          hideCancel={true}
        />
      </Base>
    </div>
  );
}

const mapStateToDispatch = (state) => ({
  nonSaleableReturns: state.nonSaleableReturn,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addNonSaleableReturn: (nonSaleableReturnData) =>
      dispatch(addNewNonSaleableReturnAction(nonSaleableReturnData)),
    deleteNonSaleableReturn: (nonSaleableReturnData) =>
      dispatch(deleteNonSaleableReturnAction(nonSaleableReturnData)),
  };
};

export default connect(
  mapStateToDispatch,
  mapDispatchToProps
)(NonSaleableReturnLandingPage);
